import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addTransCommType, getTransCommType, updateTransCommType, deleteTransCommType} from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class TransactionCommType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            transactionCommType: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (transactionCommType) => {
        this.setState({ transactionCommType: transactionCommType });
        this.setState({ deleteModal: true });
    };

    handleDelete = () => {
        const { onDelete } = this.props;
        const { transactionCommType } = this.state;

        if (transactionCommType.id !== undefined) {
            onDelete(transactionCommType);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleSubmit(value) {
        this.props.addTransCommType(value, this.props.history);
    }

    componentDidMount() {
        const { onGetTransactonCommType } = this.props;
        onGetTransactonCommType(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { transactionCommTypes } = this.props;
        if (!isEmpty(transactionCommTypes) && size(prevProps.transactionCommTypes) !== size(transactionCommTypes)) {
            this.setState({ transactionCommTypes: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ transactionCommType: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const transactionCommType = arg;
        this.setState({
            transactionCommType: {
                id: transactionCommType.id,
                transCommisisonTypeId: transactionCommType.transCommisisonTypeId,
                agentId:transactionCommType.agentId,
                title: transactionCommType.title,
                description:transactionCommType.description,
                isActive:transactionCommType.isActive
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { transactionCommTypes, onUpdate } = this.props;
        const { isEdit, deleteModal } = this.state;
        const transactionCommType = this.state.transactionCommType;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDelete}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Transaction Type | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Transaction Commssion Type")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        title: (this.state && this.state.title) || "",
                                    

                                    }}
                                    validationSchema={Yup.object().shape({
                                       
                                        title: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Commssion Type</CardTitle>
                                                    <Row>

                                                   
                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="title">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="title"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.title && touched.title
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="title"
                                                                />
                                                                <ErrorMessage
                                                                    name="title"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(transactionCommTypes, (transactionCommType, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                       
                                                                        <td>{transactionCommType.title}</td>
                                                                        <td>
                                                                        <ActionEdit onClick={() => this.toggleRightCanvas(transactionCommType)} />
                                                                        <ActionDelete onClick={() => this.onClickDelete(transactionCommType)} />
                                                                           

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: transactionCommType.id,
                                        transCommisisonTypeId: transactionCommType.transCommisisonTypeId,
                                        agentId:transactionCommType.agentId,
                                        title: transactionCommType.title,
                                        description:transactionCommType.description,
                                        isActive:transactionCommType.isActive

                                    }}
                                    validationSchema={Yup.object().shape({
                                        
                                        title: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                transCommisisonTypeId: values.transCommisisonTypeId,
                                                agentId:values.agentId,
                                                title: values.title,
                                                description:values.description,
                                                isActive:values.isActive
                                            };
                                            onUpdate(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                        
                                                        <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="title">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="title"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.title && touched.title
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="title"
                                                                />
                                                                <ErrorMessage
                                                                    name="title"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
TransactionCommType.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addTransCommType: PropTypes.func,
    onGetTransactonCommType: PropTypes.func,
    transactionCommTypes: PropTypes.array,
    onDelete: PropTypes.func,
    onUpdate: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        transactionCommTypes: AppoinmentObject.transactionCommTypes,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addTransCommType: (data) => dispatch(addTransCommType(data)),
    onGetTransactonCommType: (agentId) => dispatch(getTransCommType(agentId)),
    onDelete: (id) => dispatch(deleteTransCommType(id)),
    onUpdate: (data) => dispatch(updateTransCommType(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TransactionCommType))
